import mixins from 'vue-typed-mixins';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 業績予測三表Mixin from '@/entries/user/mixins/業績予測三表Mixin';

import { Plbscf業績予測ListItem } from '@/classes/service/Abstract計画PlbscfService';
import 業績予測Service from '@/classes/service/モニタリング/業績予測Service';
import PlbscfKeystrokeInputableTextMixin, {
  PlbscfInputableTextId,
} from '@/entries/user/mixins/PlbscfKeystrokeInputableTextMixin';

export default mixins(PlbscfKeystrokeInputableTextMixin, RoutesMixin, 業績予測三表Mixin).extend({
  name: 'C業績予測貸借対照表',

  computed: {
    bsListItems(): Plbscf業績予測ListItem[] {
      return 業績予測Service.getVisibleListBy基準値(this.計画Plbscf.bs.list, this.vモニタリング業績予測基準値);
    },
    map(): PlbscfInputableTextId[][] {
      return this.createMap(this.bsListItems, this.readonlyMonthIndex);
    },
  },

  watch: {
    keystrokeResetCount: {
      handler(): void {
        this.setFirstId();
      },
      immediate: true,
    },
  },
});
